var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 380,
    viewBox: "0 0 386 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#clip0_486_2650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.4108 425.517C160.253 425.517 217.681 368.088 217.681 297.247C217.681 226.405 160.253 168.977 89.4108 168.977C18.5691 168.977 -38.8594 226.405 -38.8594 297.247C-38.8594 368.088 18.5691 425.517 89.4108 425.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6233 131.153C107.88 131.153 122.718 145.955 122.718 164.248H185.817C185.817 111.114 142.757 68.0547 89.6233 68.0547C36.4895 68.0547 -6.57031 111.114 -6.57031 164.248H56.5283C56.5283 145.991 71.3301 131.153 89.6233 131.153V131.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.72 297.244C255.72 315.501 240.918 330.339 222.625 330.339V393.438C275.759 393.438 318.819 350.378 318.819 297.244C318.819 244.111 275.759 201.051 222.625 201.051V264.149C240.882 264.149 255.72 278.951 255.72 297.244V297.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.496 152.283V101.367C251.683 101.367 287.542 137.19 287.542 181.413H236.627C236.627 165.339 223.571 152.283 207.496 152.283V152.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.562 318.083L362.567 354.088C393.807 322.847 393.807 272.15 362.567 240.91L326.562 276.915C337.909 288.261 337.909 306.736 326.562 318.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9146 59.4345L31.9102 23.4301C63.1503 -7.81005 113.847 -7.81005 145.088 23.4301L109.083 59.4345C97.7364 48.0877 79.2614 48.0877 67.9146 59.4345Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_2650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 386,
    height: 380,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSvg);
export default __webpack_public_path__ + "static/media/footerSvg.38a9a131a482fd07710441fde733525b.svg";
export { ForwardRef as ReactComponent };